import { gql } from 'apollo-angular';
import {
  DASHBOARD_MILESTONES_FRAGMENT,
  PROJECT_DASHBOARD_FETCH_FRAGMENT,
} from '../../deals/deals-committee-dashboard/graphql/getCommitteeDashboardProject';

export var get_committee_dashboard_by_date = gql`
  ${PROJECT_DASHBOARD_FETCH_FRAGMENT}
  ${DASHBOARD_MILESTONES_FRAGMENT}
  query getCommitteeDashboardByDate(
    $mixedDate: Mixed
    $date: Date!
    $milestoneNames: Mixed
  ) {
    committeeApprovalTypes {
      id
      name
      permissions{
        _create
        _edit
        _delete
      }
    }
    milestones(
      name: $milestoneNames
      orderBy: [
        { pipelineMilestones: { column: INDEX, aggregate: MAX }, order: DESC }
      ]
    ) {
      ...DashboardMilestoneData
    }

    pipelineMilestoneDates(
      hasPipeline: { column: NAME, operator: EQ, value: "Closing" }
      hasMilestone: { column: NAME, operator: IN, value: $milestoneNames }
      hasPipelineProjectDates: {
        AND: [
          { column: INITIAL_TARGET, operator: EQ, value: false }
          { column: DATE, operator: EQ, value: $mixedDate }
        ]
      }
    ) {
      id
      pipelineProjectDates(
        date: { to: $date, from: $date }
        initial_target: false
      ) {
        id
        date
        target
        pipelineMilestone {
          milestone {
            id
            name
          }
        }
        pipelineProject {
          project {
            ...ProjectDashBoardData
          }
        }
      }
    }
  }
`;
